import { Dialog } from 'primereact/dialog'
import './ImportProject.css'
import readXlsxFile from 'read-excel-file'

import { useEffect, useRef, useState } from 'react';
import { NIST } from '../ZeroTrust/ZeroTrustData';
import { PD } from '../DataManagement/DataManagement';
import { Button } from 'primereact/button';
import { urlroot } from '../../globals/GlobalContext';
import axios from 'axios';

export function ImportProjectDialog(props:any){

    const loadSample = () => {
        axios(urlroot + 'sampleData.json').then((pd:any) => {
            PD.controls = JSON.parse(JSON.stringify(pd.data));
            props.dispatch({type: 'updateMetrics', payload: pd.data})
        });
    }

    const checkFile = (e:any) => { 
        if(e?.target?.files?.length === 0) return;
        let pd:any = {};
        readXlsxFile(e.target.files[0])
        .then((rows) => {
            rows.forEach((row:any) => {
                const nid = row[0];
                
                const nctRegex = /^\w{2}\-\d{1,2}\(\d{1,2}\)|^\w{2}\-\d{1,2}/;
                if(!nctRegex.test(nid)) return;
                if(!NIST.controls?.[nid]){
                    console.log("Could not find control: ", nid);
                    return;
                }
                const ctStatus = row[2];
                const ctDesc = row[4];

                pd[nid] = {
                    nid : nid,
                    status: ctStatus,
                    j: ctDesc,
                }
            })
            PD.controls = JSON.parse(JSON.stringify(pd));
            props.dispatch({type: 'updateMetrics', payload: pd})
        })
    }

    const header = (
        <>
            Import System Security Plan (SSP)
        </>
    )

    return(
        <Dialog header={header} visible={props.visible}
        style={{ width: '75vw', height: 'auto' }}
        onHide={() => props.dispatch({type: 'update', field: 'showImport', payload: false})}
        modal={true}
        className=''>
            <div className='flex d-flex flex-column' style={{gap: '2rem'}}>
                <div className='flex d-flex flex-row align-items-center'>
                    <strong style={{marginRight: '0.5rem'}}>Download Sample SSP:</strong> <Button size='small' label="Download" onClick={() => window.open(urlroot + 'ZT_sample_import.xlsx')} />
                </div>
                <div className='flex d-flex flex-row align-items-center'>
                    <strong style={{marginRight: '0.5rem'}}>Load sample data: </strong><Button size='small' label="Load Data" onClick={loadSample} />
                </div>
                <hr/>
                <div>
                    <strong>Upload SSP: </strong><br/>
                    <input type="file"
                        id="avatar" name="avatar"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" 
                        onChange={checkFile}/>
                </div>
            </div>
        </Dialog>
    )
}

export default function ImportProject(props:any){
    return(
        <></>
    )
}